export default function Testimonials() {
  return (
    <section id="testimonios" className="bg-[#080808] py-20 md:py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <span className="text-[#00FF88] text-sm font-bold uppercase tracking-widest">Resultados Reales</span>
          <h2 className="text-3xl md:text-4xl font-black text-white mt-3">Lo que dice la comunidad:</h2>
          <div className="w-16 h-1 bg-[#00FF88] rounded-full mt-4"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* Main testimonial */}
          <div className="flex-1">
            <div className="relative bg-[#111] rounded-2xl p-8 md:p-10 h-full">
              <span className="absolute top-6 right-8 text-8xl font-black leading-none opacity-10 text-white">"</span>
              <p className="text-white text-xl leading-relaxed mb-8 relative z-10">
                "Antes perdía ventas por no saber qué productos me quedaban. Con Stock Simple mi embudo fluye sin cortes.
                El control de inventario me cambió el juego. Recomendado al 100%."
              </p>
              <div className="border-t border-white/10 pt-6 flex items-center gap-4">
                <img
                  alt="Carlos M."
                  className="w-14 h-14 rounded-full object-cover flex-shrink-0"
                  src="https://readdy.ai/api/search-image?query=professional%20latin%20man%20headshot%20portrait%2C%20confident%20business%20owner%2C%20dark%20background%2C%20warm%20neutral%20tones%2C%20professional%20photography%2C%20close-up%20face&width=80&height=80&seq=avatar-carlos-05&orientation=squarish"
                />
                <div>
                  <p className="text-white font-bold">Carlos M.</p>
                  <p className="text-gray-500 text-sm">E-commerce · Lima</p>
                </div>
                <div className="ml-auto flex gap-1">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#00FF88] text-sm"></i>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Side testimonial + stats */}
          <div className="lg:w-80 lg:mt-12">
            <div className="relative bg-[#111] rounded-2xl p-8">
              <span className="absolute top-4 right-6 text-7xl font-black leading-none opacity-10 text-white">"</span>
              <p className="text-white text-base leading-relaxed mb-6 relative z-10">
                "Descubrí fugas de dinero tontas que no veía. Una inversión de $12 me salvó el mes."
              </p>
              <div className="border-t border-white/10 pt-5 flex items-center gap-3">
                <img
                  alt="Lucía R."
                  className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                  src="https://readdy.ai/api/search-image?query=professional%20latin%20woman%20headshot%20portrait%2C%20confident%20businesswoman%2C%20dark%20background%2C%20warm%20neutral%20tones%2C%20professional%20photography%2C%20close-up%20face&width=80&height=80&seq=avatar-lucia-06&orientation=squarish"
                />
                <div>
                  <p className="text-white font-bold text-sm">Lucía R.</p>
                  <p className="text-gray-500 text-xs">Traficker · Arequipa</p>
                </div>
              </div>
              <div className="flex gap-1 mt-4">
                {[1, 2, 3, 4, 5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#FF6B35] text-sm"></i>
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="mt-6 bg-[#111] rounded-2xl p-6 border border-white/5">
              <div className="grid grid-cols-2 gap-4">
                {[
                  { value: '+500', label: 'Estrategas' },
                  { value: '98%', label: 'Satisfacción' },
                  { value: '$12', label: 'Al año' },
                  { value: '24/7', label: 'Acceso' },
                ].map((stat, i) => (
                  <div key={i} className="text-center">
                    <p className="text-[#00FF88] text-2xl font-black">{stat.value}</p>
                    <p className="text-gray-500 text-xs">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
